"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var enhanceWithClickOutside = require("react-click-outside");
var styles_1 = require("./styles");
var ClickOutsideTooltip = /** @class */ (function (_super) {
    __extends(ClickOutsideTooltip, _super);
    function ClickOutsideTooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClickOutside = function () {
            _this.props.handleClickOutside();
        };
        return _this;
    }
    ClickOutsideTooltip.prototype.render = function () {
        var _a = this.props, handleClickOutside = _a.handleClickOutside, rest = __rest(_a, ["handleClickOutside"]);
        return React.createElement(styles_1.StyledReactTooltip, __assign({}, rest));
    };
    return ClickOutsideTooltip;
}(React.Component));
exports.default = enhanceWithClickOutside(ClickOutsideTooltip);
//# sourceMappingURL=ClickOutsideTooltip.js.map